import { render, staticRenderFns } from "./classhourTag.vue?vue&type=template&id=45993fe8&scoped=true"
import script from "./classhourTag.vue?vue&type=script&lang=ts"
export * from "./classhourTag.vue?vue&type=script&lang=ts"
import style0 from "./classhourTag.vue?vue&type=style&index=0&id=45993fe8&prod&lang=less&scoped=true"
import style1 from "./classhourTag.vue?vue&type=style&index=1&id=45993fe8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45993fe8",
  null
  
)

export default component.exports